import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Native-Angular port of the AngularJS `quot` filter
 * (account-v1/.../text-formatting/quot.js): wraps text in HTML quote entities and
 * trusts it as HTML (used with [innerHTML], like the original's ng-bind-html).
 */
@Pipe({
    name: 'quot',
    standalone: false
})
export class QuotPipe implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(text: string | null | undefined): SafeHtml {
    if (!text) return '';
    return this.sanitizer.bypassSecurityTrustHtml('&quot;' + text + '&quot;');
  }
}
